export default "__VITE_PUBLIC_ASSET__e8e26271__"